import React, { useEffect, useState } from 'react';

import { ValueBox, ValueBoxGroupOptions, ValueStepper } from '@candu-ai/craft/ui';
import { getCssResetStyleMessage, StylesHierarchy } from 'craft/hooks';
import { useViewportBreakpoint } from 'craft/state';

interface Props {
  cssProps: Record<string, unknown>;
  setCss: (e: Record<string, unknown>) => void;
  variant: string;
  stylesHierarchy: StylesHierarchy;
  isInGroup?: ValueBoxGroupOptions;
}

export const LineHeight = ({ cssProps, setCss, isInGroup, stylesHierarchy, variant }: Props) => {
  const { lineHeight } = cssProps;
  const viewport = useViewportBreakpoint();

  const defaultValue = parseFloat((stylesHierarchy?.lineHeight?.fallbackValue || '') as string);
  const [inputValue, setInputValue] = useState<number | undefined>(
    lineHeight ? parseFloat(lineHeight as string) : defaultValue,
  );

  useEffect(() => {
    setInputValue(lineHeight ? parseFloat(lineHeight as string) : defaultValue);
  }, [variant, viewport]);

  return (
    <ValueBox label="Line Height" isInGroup={isInGroup}>
      <ValueStepper
        scale="small"
        editable
        minValue={1}
        maxValue={999}
        step={1}
        onResetTooltip={getCssResetStyleMessage(stylesHierarchy?.lineHeight?.fallbackStyle)}
        onReset={
          !!lineHeight && inputValue !== defaultValue
            ? () => {
                setInputValue(defaultValue);
                setCss({ lineHeight: undefined });
              }
            : undefined
        }
        onBlur={() => {
          if (typeof inputValue === 'undefined') {
            setInputValue(defaultValue);
          }
        }}
        onChange={(newValue?: number) => {
          setInputValue(newValue);
          if (newValue === defaultValue) {
            setCss({ lineHeight: undefined });
            return;
          }
          // only trigger change when there is no value or the value is within the accepted range
          if (typeof newValue === 'undefined' || (newValue >= 1 && newValue <= 999)) {
            setCss({ lineHeight: typeof newValue !== 'undefined' ? `${newValue}px` : newValue });
          }
        }}
        valueSuffix="px"
        value={inputValue}
      />
    </ValueBox>
  );
};
